<template>
	<div class="layout-footer">
		<span class="font-medium ml-2">&copy; Harborwall 2022</span>
	</div>
</template>

<script>
	export default {
		name: "AppFooter",
		methods: {
		
		},
		computed: {
		
		}
	}
</script>